import {INTERSECT, UNION, SUBTRACT} from './operation-types.js';

export const applyOperation = (a,b, first, operation) => {
    if (operation === UNION || !operation) {
        // essentially doing min(a,b)
        let gen = `
  if (${a}.x < ${first ? b : 'scene'}.x) {
    scene = ${a};
  }
`;
        if (first) {
            gen +=  `
  else {
    scene = ${b};
  }
`;
        }
        return gen;
    } else if (operation === INTERSECT) {
        // essentially doing max(a,b)
        let gen = `
  if (${a}.x < ${first ? b : 'scene'}.x) {
    scene = ${b};
  }
`;
        if (first) {
            gen +=  `
  else {
    scene = ${a};
  }
`;
        }
        return gen;
    } else if (operation === SUBTRACT) {
        // essentially doing max(a,b)
        let gen = `
  if (-${a}.x > ${first ? b : 'scene'}.x) {
    scene = ${a};
  }
`;
        if (first) {
            gen +=  `
  else {
    scene = ${b};
  }
`;
        }
        return gen;
    }
    return '';
};

export const generateScene  = (codes, first=true, operations) => {
    if (first && codes.length === 1) {
        return `scene = ${codes[0]}`;
    }
    if (codes.length === 0) {
        return 'scene = vec2(0.0, -1.0)';
    }
    let gen = applyOperation(
        codes[0],
        first ? codes[1] : 'scene',
        first,
        operations && operations[0]
    );

    let recur = codes.length === 1 ? '' : generateScene(first ? codes.slice(2) : codes.slice(1), false, operations && operations.slice(1));
    return gen + recur;
};

